import { render } from "./ComponenteCatalogo.vue?vue&type=template&id=9a436664&scoped=true"
import script from "./ComponenteCatalogo.vue?vue&type=script&lang=js"
export * from "./ComponenteCatalogo.vue?vue&type=script&lang=js"

import "./ComponenteCatalogo.vue?vue&type=style&index=0&id=9a436664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a436664"]])

export default __exports__